import type { IntegrationHostName } from '../../../../contexts/ClientNameContext';
import type { TooltipMedia } from '../../../stores/tooltipStore.types';

const INTEGRATION_EXPORT_CTA_TARGETS: Record<IntegrationHostName, string> = {
  premiere: '[data-testid="export-cta"][data-integration-host="premiere"]',
  aftereffects:
    '[data-testid="export-cta"][data-integration-host="aftereffects"]',
};

export function getIntegrationExportCtaTarget(
  host: IntegrationHostName
): string {
  return INTEGRATION_EXPORT_CTA_TARGETS[host];
}

export const INTEGRATION_EXPORT_ONBOARDING_MEDIA: TooltipMedia = {
  mediaType: 'video',
  src: 'https://embed.wistia.com/deliveries/fad17e92d6a3e2741af4b007c79a50fe709aac92.mp4',
  alt: 'Export for review',
  aspectRatio: 2076 / 1080,
};

export const INTEGRATION_EXPORT_ONBOARDING_BASE = {
  delayMs: 1000,
  showAfterVisitNumber: 1,
  routes: ['/sequences'],
  placement: 'bottom' as const,
  precedence: 0,
  maxWidth: '360px',
  variant: 'Body' as const,
  media: INTEGRATION_EXPORT_ONBOARDING_MEDIA,
};
